/** @format */

const template = `
<sis-dropdown-select
  [options]="$ctrl.options"
  [id]="$ctrl.id"
  [selection]="$ctrl.selection"
  [disabled]="$ctrl.disabled"
  [required]="$ctrl.required"
  [compact]="$ctrl.compact"
  [align-right]="$ctrl.alignRight"
  [aria-labelled-by]="$ctrl.ariaLabelledBy"
  [container]="$ctrl.container"
  [scope]="$ctrl.$scope"
  (selection-change)="$ctrl.setValue($event)"
  [track-by-index]="$ctrl.trackByIndex">
</sis-dropdown-select>
`;
export default template;
